import React from 'react';
import GenericCRUDPage from '../../components/GenericCRUDPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { FormField, Input, Select, Textarea, Badge } from '../../components/UI';
import { customerService } from '../../api/services';
import { formatCurrency } from '../../utils/helpers';
import { toJalali } from '../../utils/jalali';

const CustomerFormFields = ({ form: { register, watch, setValue, formState: { errors } } }) => (
  <div className="grid grid-cols-2 gap-4">
    <FormField label="Full Name" required error={errors.name?.message}>
      <Input {...register('name', { required: 'Required' })} placeholder="Customer name" />
    </FormField>
    <FormField label="Phone">
      <Input {...register('phone')} placeholder="+93 700 000 000" />
    </FormField>
    <FormField label="Email">
      <Input type="email" {...register('email')} placeholder="email@example.com" />
    </FormField>
    <FormField label="Date of Birth">
      <JalaliDatePicker value={watch('dateOfBirth')||''} onChange={v=>setValue('dateOfBirth',v)} placeholder="Date of birth" className="w-full"/>
    </FormField>
    <FormField label="Gender">
      <Select {...register('gender')}>
        <option value="">Select gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </Select>
    </FormField>
    <div className="col-span-2">
      <FormField label="Address">
        <Textarea {...register('address')} placeholder="Address" rows={2} />
      </FormField>
    </div>
  </div>
);

const columns = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'gender', label: 'Gender', render: (v) => v ? <span className="capitalize">{v}</span> : '-' },
  { key: 'balance', label: 'Balance', render: (v) => <span className={v < 0 ? 'text-red-600 font-medium' : 'text-gray-700'}>{formatCurrency(v || 0)}</span> },
  { key: 'createdAt', label: 'Registered', render: (v) => toJalali(v) },
  { key: 'isActive', label: 'Status', render: (v) => <Badge color={v ? 'green' : 'gray'}>{v ? 'Active' : 'Inactive'}</Badge> },
];

export default function CustomersPage() {
  return (
    <GenericCRUDPage
      title="Customers"
      subtitle="Manage customer records"
      service={customerService}
      entityName="Customer"
      columns={columns}
      FormFields={CustomerFormFields}
      modalSize="lg"
    />
  );
}
